export enum InvestmentsExperimentFlag {
  MarketInvestmentsFlow = 'market_investments_flow',
  StoreInvestmentsNewModule = 'store_investments_new_module'
}
